<template>
    <div class="regicall-client-bio">
        <div class="loader-container"
            v-if="!client">
            <page-loader :loading="loading"></page-loader>
        </div>
        <div v-if="client">
            <div class="mt-1 columns is-centered">
                <AvatarCircle :src="client.avatar"></AvatarCircle>
            </div>
            <h3 class="has-text-centered">{{client.name}}</h3>
            <hr class="my-1">
            <div class="columns is-marginless">
                <div class="column is-paddingless" :title="`woonplaats: ${client.city}`">
                    <span class="icon">
                        <i class="fas fa-map-marker-alt"></i>
                    </span>{{client.city}}
                </div>
                <div class="column is-paddingless" :title="`leeftijd: ${client.age} jaar`">
                    <span class="icon">
                        <i class="fa fa-birthday-cake"></i>
                    </span><span v-if="client.age">{{client.age}} jaar</span><span v-else>onbekend</span>
                </div>
            </div>
            <div class="columns is-marginless">
                <div class="column is-paddingless" :title="`geslacht: ${client.sexName}`">
                    <span class="icon">
                        <i class="fas fa-venus-mars"></i>
                    </span>{{client.capitalize(client.sexName)}}
                </div>
                <div class="column is-paddingless" :title="`geboortedatum: ${client.date_of_birth}`">
                    <span class="icon">
                        <i class="fas fa-baby"></i>
                    </span><span v-if="client.date_of_birth">{{client.formatDate(client.date_of_birth)}}</span><span v-else>onbekend</span>
                </div>
            </div>
            <hr class="my-1">
            <table class="table is-narrow is-fullwidth">
                <tbody>
                    <tr>
                        <td class="is-italic is-borderless">Aangemeld op</td>
                        <td class="is-borderless">{{client.formatDate(client.signed_up)}}</td>
                    </tr>
                    <tr>
                        <td class="is-italic is-borderless">Laatste gesprek</td>
                        <td class="is-borderless">{{lastCall}}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="client.reason">
                <hr class="my-1">
                <span class="is-italic">Reden van deelname</span>
                <br>
                <p>{{ formattedReason }}</p>
            </div>
        </div>
    </div>
</template>

<script>
  import { Client } from '../../../models/Client';
  import AvatarCircle from '../../../components/AvatarCircle';
  import PageLoader from '../../../components/PageLoader';
  import moment from 'moment';

  export default {
    components: {
      AvatarCircle, PageLoader
    },
    props: {
      client: {
        type: Client,
        required: true
      }
    },
    computed: {
      lastCall () {
        if (!this.client.last_call) {
          return '';
        }

        const duration = moment.duration(
          moment().diff(moment(this.client.last_call))
        );
        if (duration.months() > 1) {
          return duration.months() + ' maanden geleden';
        }
        if (duration.days() > 1) {
          return duration.days() + ' dagen geleden';
        }
        return duration.hours() + ' uur geleden';
      },
      formattedReason () {
        if (!this.client.reason) {
          return '';
        }
        return `'${this.client.reason}'`;
      }
    },
    methods: {
      async loadData () {
        await Client.$get({ params: { id: 1 }});
      }
    }
  };
</script>

<style lang="scss" scoped>

  .avatar {
    width: 80px;
    height: 80px;
  }

</style>